/**
 * Utilidad para construir URLs de archivos en storage
 * Las rutas de storage NO deben incluir /api, solo el dominio del backend
 */

export const getStorageUrl = (path) => {
  if (!path) {
    return null;
  }

  // Si ya es una URL completa, devolverla tal cual
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Obtener la URL base del backend (sin /api)
  let baseUrl;
  
  if (process.env.REACT_APP_API_URL) {
    // Si REACT_APP_API_URL está definido, quitar /api del final
    baseUrl = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');
  } else if (process.env.NODE_ENV === 'production') {
    // En producción, usar el dominio del API sin /api
    baseUrl = 'https://api.runniaapp.com';
  } else {
    // En desarrollo, usar localhost sin /api
    baseUrl = 'http://localhost:8000';
  }

  // Asegurar que el path comience con /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${baseUrl}${normalizedPath}`;
};


